module.exports = __webpack_public_path__ + "img/ambiente.5f20a32e.png";